type CryptoWithUUID = Crypto & {
  randomUUID: () => string
}

export const generateUUID = (): string => {
  if (
    typeof crypto !== 'undefined' &&
    typeof (crypto as CryptoWithUUID).randomUUID === 'function'
  ) {
    return (crypto as CryptoWithUUID).randomUUID()
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
}
